<template>
  <BaseListItem>
    <div class="flex -mx-3">
      <div class="w-24 px-3">
        <RouterLink
          :to="{ name: 'accounts.show', params: { accountId: (relatedAccount || supplier).id } }"
          class="capitalize"
        >
          <template v-if="relatedAccount && relatedAccount.logo">
            <img :src="relatedAccount.logo" class="block rounded w-full" />
          </template>
          <template v-else>
            <div class="aspect-ratio-square w-full rounded bg-gray-200" />
          </template>
        </RouterLink>
      </div>
      <div class="flex-1 px-3 capitalize">
        <RouterLink v-if="entity.can.view" :to="to">
          {{ entity.name }}
        </RouterLink>
        <span v-else>{{ entity.name }}</span>
        <br />
        <span class="text-gray-700">{{ supplier.name }}</span>
        <br />
        <ul class="flex -mx-1 flex-wrap">
          <li v-for="tag in tags" :key="tag.id" class="p-1">
            <BaseBadge
              custom
              :style="{
                backgroundColor: tag.customProperties.background,
                color: tag.customProperties.color,
              }"
              class="whitespace-nowrap"
            >
              {{ tag.name }}
            </BaseBadge>
          </li>
        </ul>
      </div>
      <div class="w-48 px-3 text-right">
        <BaseBadge silver>
          {{ status.name }}
        </BaseBadge>
      </div>
      <div class="w-32 px-3 text-right">{{ entity.price }} EURO</div>
      <div class="w-32 px-3 text-right">
        {{ entity.deliveryAtForHumans }}
      </div>
      <div class="w-32 px-3 text-right">
        {{ entity.createdAtForHumans }}
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', {
      client(state) {
        return state.accountRelations.byId[this.entity.clientUuid] || null;
      },
      relatedAccount(state) {
        if (!this.client) return null;
        if (!this.client.related_account_uuid) return null;
        return state.accounts.byId[this.client.related_account_uuid] || null;
      },
      supplier(state) {
        return state.accounts.byId[this.entity.supplierUuid] || null;
      },
      status(state) {
        return state.orderStatuses.byId[this.entity.statusId] || null;
      },
      tags(state) {
        return this.entity.tags.map((id) => state.orderTags.byId[id]);
      },
    }),
    to() {
      const { type, accountUuid, uuid } = this.entity;
      const { id: accountId } = this.relatedAccount || { related_account_uuid: accountUuid };

      if (type === 'production') {
        return {
          name: 'accounts.productionOrders.productionOrderUuid',
          params: { accountId, productionOrderUuid: uuid },
        };
      }
      return {
        name: 'accounts.orders.show',
        params: { accountId, orderId: uuid },
      };
    },
  },
};
</script>
